import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BackgroundModel, ButtonStyleModel, EventsService } from 'simpo-component-library';

@Component({
  selector: 'app-button-style-editor',
  templateUrl: './button-style-editor.component.html',
  styleUrls: ['./button-style-editor.component.scss']
})
export class ButtonStyleEditorComponent {
  constructor(
    private eventService: EventsService){}

    selectedTab : 'Theme' | 'Custom' = "Theme";
    @Input() buttonStyle!: ButtonStyleModel;
    @Input() id! : string;
    @Input() btnId!: string;
    @Input() color!: string;
    @Input() backgroundInfo?: BackgroundModel;

    ngOnInit() {
      this.selectedStyle = (this.buttonStyle.shape === 'Round' && this.buttonStyle.type === 'Outline') ? 'Style 1' : 'Style 2'
    }

    changeTabs(selectedTab: 'Theme' | 'Custom'){
      this.selectedTab = selectedTab;

    }

    styles = [
      {
        name: 'Style 1',
        type: 'Outline',
        shape: 'Round'
      },
      {
        name: 'Style 2',
        type: 'Solid',
        shape: 'Round'
      }
    ]

    selectedStyle: string = 'Style 1'
    changeButtonStyle(style: any){
      this.buttonStyle.shape = style.shape;
      this.buttonStyle.type = style.type;

      this.eventService.buttonStyleChangeChecks.emit({id: this.id+this.btnId, style: this.buttonStyle, backgroundInfo: this.backgroundInfo});
      this.selectedStyle = style.name;
    }

    type = [
      {
        value: 'Solid'
      },
      {
        value: 'Outline'
      }
    ]

    shape = [
      {
        value: 'Round'
      },
      {
        value: 'Square'
      }
    ]

    changeButtonStle(){
      this.eventService.buttonStyleChangeChecks.emit({id: this.id+this.btnId, style: this.buttonStyle, backgroundInfo: this.backgroundInfo});
    }
}

